<template>
    <VMenu
        :delay="{ show: 100, hide: 100 }"
        :disabled="disablePopover"
        placement="top"
        popper-class="ExceptionBadge__tooltip"
    >
        <Badge class="ExceptionBadge">
            <FontAwesomeIcon :icon="faInfoCircle" />
            {{ label }}
        </Badge>
        <template #popper>
            <div class="ExceptionBadge__popoverContent">
                <span v-if="exceptionTypeLabel" class="ExceptionBadge__popoverContentLine">
                    <strong>Type: </strong>
                    <span>{{ exceptionTypeLabel }}</span>
                </span>
                <span v-if="until" class="ExceptionBadge__popoverContentLine">
                    <strong>Expiration: </strong>
                    <span>{{ until || 'none' }}</span>
                </span>
                <span v-if="appliedToLabel" class="ExceptionBadge__popoverContentLine">
                    <strong>Applied to: </strong>
                    <span>{{ appliedToLabel }}</span>
                </span>
                <span v-if="requiredMessage" class="ExceptionBadge__popoverContentLine">
                    <strong>Required: </strong>
                    <span>{{ requiredMessage }}</span>
                </span>
                <span class="ExceptionBadge__popoverContentLine">
                    <b>Note:</b> {{ note || 'No notes provided' }}
                </span>
            </div>
        </template>
    </VMenu>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { Menu as VMenu } from 'floating-vue';
    import startCase from 'lodash/startCase';

    import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Badge } from '@evidentid/dashboard-commons/components/Badge';
    import { ExceptionLevel, ExceptionType } from '@evidentid/tprm-portal-lib/models/entity-details';

    export default defineComponent({
        name: 'ExceptionBadge',
        components: {
            Badge, FontAwesomeIcon, VMenu,
        },
        props: {
            label: {
                type: String as PropType<string>,
                default: 'Exception',
            },
            requiredMessage: {
                type: String as PropType<string>,
                default: '',
            },
            exceptionType: {
                type: String as PropType<string>,
                default: '',
            },
            appliedTo: {
                type: String as PropType<string>,
                default: '',
            },
            until: {
                type: [ String, null ] as PropType<string | null>,
                default: null,
            },
            disablePopover: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            note: {
                type: [ String, null ] as PropType<string | null>,
                default: null,
            },
        },
        data() {
            return {
                faInfoCircle,
            };
        },
        computed: {
            exceptionTypeLabel(): string {
                if (this.exceptionType === ExceptionType.untilCoverageExpiration) {
                    return 'Applies to Current Policy';
                }
                return startCase(this.exceptionType.toLowerCase());
            },
            appliedToLabel(): string {
                if (this.appliedTo === ExceptionLevel.insured) {
                    return 'Entity';
                } else if (this.appliedTo === ExceptionLevel.requirementInstance) {
                    return 'Requirement';
                } else {
                    return startCase(this.appliedTo.toLowerCase());
                }
            },
        },
    });

</script>
